export const baseEvent = {
  context: 'RENT_PAYMENT',
} as const
